'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _recompose = require('recompose');

var _reactRouterRedux = require('react-router-redux');

var _reactRedux = require('react-redux');

var _Button = require('../buttons/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Icon = require('../icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

require('./ModalBackButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, _ref) {
    var backButtonRoutes = _ref.backButtonRoutes;
    return {
        showBackButton: backButtonRoutes && backButtonRoutes.indexOf(state.get('routing').locationBeforeTransitions.pathname) !== -1
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        goBackHistory: function goBackHistory() {
            return dispatch((0, _reactRouterRedux.goBack)());
        }
    };
};

var ModalBackButton = function ModalBackButton(_ref2) {
    var showBackButton = _ref2.showBackButton,
        handleBackClick = _ref2.handleBackClick,
        className = _ref2.className,
        _ref2$title = _ref2.title,
        title = _ref2$title === undefined ? 'Back' : _ref2$title;

    if (!showBackButton) return null;

    return _react2.default.createElement(
        _Button2.default,
        {
            onClickFn: handleBackClick,
            className: (0, _classnames2.default)('ModalBackButton', className) },
        _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_Icon2.default, { name: 'chevron-left' })
        ),
        ' ',
        title
    );
};

ModalBackButton.propTypes = {
    showBackButton: _propTypes2.default.bool,
    handleBackClick: _propTypes2.default.func,
    className: _propTypes2.default.string,
    title: _propTypes2.default.string
};

var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withHandlers)({
    handleBackClick: function handleBackClick(_ref3) {
        var goBackHistory = _ref3.goBackHistory;
        return function (event) {
            goBackHistory();
        };
    }
}));

exports.default = enhance(ModalBackButton);


//////////////////
// WEBPACK FOOTER
// ./src/client/components/modal/ModalBackButton.js
// module id = 1914
// module chunks = 0